import { useState, useEffect } from 'react';
import formsConfig from '../config/formsConfig.json';

export const useFormStatus = (formName) => {
  const [status, setStatus] = useState(null);
  const [openAt, setOpenAt] = useState(null);
  const [closeAt, setCloseAt] = useState(null);
  const [isActive, setIsActive] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getFormStatus = () => {
      try {
        setLoading(true);
        setError(null);
        console.log(formName);
        const formConfig = formsConfig.forms[formName];

        if (!formConfig) {
          setStatus('غير مفعل');
          setIsActive(false);
          setOpenAt(null);
          setCloseAt(null);
          setLoading(false);
          return;
        }

        const now = new Date();
        const startTime = new Date(formConfig.startTime);
        const endTime = new Date(formConfig.endTime);

        setOpenAt(formConfig.startTime);
        setCloseAt(formConfig.endTime);

        // Check if current time is within the form's active period
        if (now >= startTime && now <= endTime) {
          setStatus('مفتوح');
          setIsActive(true);
        } else if (now < startTime) {
          setStatus('لم يفتح بعد');
          setIsActive(false);
        } else {
          setStatus('مغلق');
          setIsActive(false);
        }

        setLoading(false);
      } catch (err) {
        console.error('Error loading form status:', err);
        setError(err.message);
        setStatus('خطأ في التحميل');
        setIsActive(false);
        setLoading(false);
      }
    };

    getFormStatus();
  }, [formName]);

  return {
    status,
    openAt,
    closeAt,
    isActive,
    loading,
    error,
    isOpen: status === 'مفتوح'
  };
};
